export default "__VITE_ASSET__DGtt223P__"